const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

// The backend can return image urls as http:// and redirects them to https://. That redirect carries no CORS
// headers, so loading the image with crossOrigin (needed by the canvas) fails. Going straight to https avoids it.
export const toSecureImageUrl = (url: string): string => {
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'http:' && !LOCAL_HOSTS.has(parsed.hostname)) {
      parsed.protocol = 'https:';
      return parsed.toString();
    }
  } catch {
    // Not an absolute url (relative path, data/blob url...): use it as is.
  }
  return url;
};

// The lists serve ".../thumb" (blurry); the same path without it is the original image.
export const toFullImageUrl = (url: string): string => url.replace(/\/thumb(?=$|[?#])/, '');

// Lists must show the 200x200 thumbnail; adds "/thumb" when the url doesn't already end with it.
export const toThumbImageUrl = (url: string): string =>
  /\/thumb(?=$|[?#])/.test(url) ? url : url.replace(/\/?(?=$|[?#])/, '/thumb');
